export default __webpack_public_path__ + "static/media/MiniTape_SideB_04_Schützenfest-Intermission.45ebc668.mp3";